import { TopologySubscription } from '../../../../../services/eventingApi';

export const subscribedEventTypes = (subscription: TopologySubscription): string[] => {
  const values = subscription.filterPolicy?.eventType;
  return Array.isArray(values) ? values.filter((value): value is string => typeof value === 'string') : [];
};

export const acceptsEventType = (subscription: TopologySubscription, eventType: string) => {
  const types = subscribedEventTypes(subscription);
  return types.length === 0 || types.includes(eventType);
};

export const queueSubscriptions = (subscriptions: TopologySubscription[]) =>
  subscriptions.filter((subscription) => subscription.queueName !== null);
